import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconMathEqualsCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMathEqualsCircle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M8.5 10.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 13.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMathEqualsCircle;
